<template>
	<div class="flex flex-col sm:flex-row sm:items-center sm:gap-3">
		<!-- Mobile: Label and badge header -->
		<div class="mb-2 flex items-center justify-between sm:hidden">
			<span class="text-sm font-medium text-gray-700"
				>{{ t("note.severity") }}:</span
			>
			<span
				class="min-w-[2rem] rounded px-2 py-1 text-center text-sm font-semibold"
				:class="getSeverityColorClass(model)"
			>
				{{ model }}
			</span>
		</div>

		<!-- Desktop: Label only -->
		<span
			class="hidden flex-shrink-0 text-sm font-medium text-gray-700 sm:block"
		>
			{{ t("note.severity") }}:
		</span>

		<!-- Slider -->
		<ion-range
			v-model="model"
			:min="1"
			:max="10"
			:pin="true"
			:ticks="true"
			:snaps="true"
			class="pt-0 sm:flex-1"
		>
			<div slot="start" class="text-xs text-gray-500">1</div>
			<div slot="end" class="text-xs text-gray-500">10</div>
		</ion-range>

		<!-- Desktop: Badge at the end -->
		<span
			class="hidden min-w-[2rem] flex-shrink-0 rounded px-2 py-1 text-center text-sm font-semibold sm:block"
			:class="getSeverityColorClass(model)"
		>
			{{ model }}
		</span>
	</div>
</template>

<script setup lang="ts">
	import { IonRange } from "@ionic/vue";
	import { useI18n } from "vue-i18n";

	const { t } = useI18n();
	const model = defineModel<number>({ default: 5 });

	const getSeverityColorClass = (severity: number): string => {
		if (severity <= 3) return "bg-green-100 text-green-800";
		if (severity <= 6) return "bg-yellow-100 text-yellow-800";
		if (severity <= 8) return "bg-orange-100 text-orange-800";
		return "bg-red-100 text-red-800";
	};
</script>
